import { useMutation, useQueryClient } from "@tanstack/react-query";
import { playersApi } from "../../api/players";
import { playerKeys } from "../queries/usePlayer";

export const useUpdatePlayer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: playersApi.update,
    onSuccess: (_data, player) => {
      queryClient.invalidateQueries({ queryKey: playerKeys.detail(player.id) });
      queryClient.invalidateQueries({ queryKey: playerKeys.all });
    },
  });
};

export const useCreatePlayer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: playersApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: playerKeys.all });
    },
  });
};
